export default function headerRequest() {
    let user = JSON.parse(localStorage.getItem("infoAssisProd"));
    if (user && user.token) {
      return { 'Authorization': "Bearer " + user.token };
    }
}